export default __webpack_public_path__ + "static/media/14.036b8747.jpeg";